import React, { useEffect, useState } from "react";
import AgentSidebar from "./AgentSidebar";
import Header2 from "./Header2";

const AgentLayout = ({ children }) => {
  const [pageTitle, setPageTitle] = useState("dashboard");
  const [isOpen, setIsOpen] = useState(false); // State للـ Sidebar (مغلق افتراضيًا)

  // كشف الموبايل (lg breakpoint = 1024px)
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1024);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // على الديسكتوب، خلي الـ Sidebar مفتوح دايمًا
  useEffect(() => {
    if (!isMobile) {
      setIsOpen(true);
    } else {
      setIsOpen(false); // على الموبايل، مغلق افتراضيًا
    }
  }, [isMobile]);

  // دالة الـ toggle للـ Sidebar
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // دالة الإغلاق (للـ overlay أو close button)
  const closeSidebar = () => setIsOpen(false);

  return (
    <main className="flex flex-row w-full min-h-screen bg-background-main relative">
      {/* Overlay للموبايل فقط (رمادي شفاف) */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <AgentSidebar
        setPageTitle={setPageTitle}
        isOpen={isOpen}
        onToggle={toggleSidebar}
        onClose={closeSidebar}
        isMobile={isMobile}
      />

      {/* Main Content */}
      <div className="flex flex-col w-full lg:w-[82%] gap-5 flex-1 z-10">
        <Header2 pageTitle={pageTitle} onSidebarToggle={toggleSidebar} />
        <div className="flex-1 p-4 overflow-auto">{children}</div> {/* أضفت p-4 للـ padding، أزل لو مش عايز */}
      </div>
    </main>
  );
};

export default AgentLayout;
